<template>
	<div class="account-summary-edit">
		<div
			class="wrapper-btn-back"
			:style="`background-color:${globalColors.primary}`"
		>
			<button 
				class="account-summary-edit-back"
				@click="$emit('close-modal')">
				<img 
					src="/static/img/arrow-back.svg" 
					alt="ir hacia atras"
					class="arrow-back">
			</button>
			<p class="bold txt-center title-btn">RESUMEN DE CUENTA</p>
		</div>
		<div
			class="account-summary-edit-title bold mb-2"
			:style="`color:${globalColors.primary}`"
		>RESUMEN DE CUENTA</div>
		<div class="wrapper-list-item">
			<el-form :model="userEdit" class="d-flex wrap">
				<el-form-item prop="name" class="mb-2 flex-40 mx-1">
					<el-input
						class="qtc-input"
						placeholder="Nombre"
						v-model="userEdit.name"
					></el-input>
				</el-form-item>
				<el-form-item prop="dni" class="mb-2 flex-40 mx-1">
					<el-input
						class="qtc-input"
						v-model="userEdit.dni"
						:placeholder="documentLabel"
					></el-input>
				</el-form-item>
				<el-form-item prop="lastname" class="mb-2 flex-40 mx-1">
					<el-input
						class="qtc-input"
						placeholder="Apellido"
						v-model="userEdit.lastname"
					></el-input>
				</el-form-item>
				<el-form-item prop="ruc" class="mb-2 flex-40 mx-1">
					<el-input
						class="qtc-input"
						v-model="userEdit.ruc"
						placeholder="RUC"
					></el-input>
				</el-form-item>
				<el-form-item prop="gender" class="mb-2 flex-40 mx-1">
					<select-component
						placeholder="Género"
						item-text="title"
						item-value="id"
						:options="genders"
						v-model="userEdit.gender"
					/>
				</el-form-item>
				<el-form-item prop="postalCode" class="mb-2 flex-40 mx-1">
					<el-input
						class="qtc-input"
						v-model="userEdit.postalCode"
						placeholder="Código Postal"
					></el-input>
				</el-form-item>
				<el-form-item prop="department" class="mb-2 flex-40 mx-1">
					<select-component
						:placeholder="countryLabels.department"
						item-text="name"
						item-value="id"
						:options="departments"
						v-model="userEdit.provinceId"
						@input="onDepartamenChange($event, true)"
					/>
				</el-form-item>
				<el-form-item prop="province" class="mb-2 flex-40 mx-1">
					<select-component
						:placeholder="countryLabels.province"
						item-text="name"
						item-value="id"
						:options="provinces"
						v-model="userEdit.cityId"
						@input="onProvinceChange($event, true)"
						:disabled="!userEdit.provinceId"
					/>
				</el-form-item>
				<el-form-item prop="parish" class="mb-2 flex-40 mx-1">
					<select-component
						:placeholder="countryLabels.district"
						item-text="name"
						item-value="id"
						:options="districts"
						v-model="userEdit.parishId"
						:disabled="!userEdit.cityId"
					/>
				</el-form-item>
				<el-form-item prop="address" class="mb-2 flex-40 mx-1">
					<el-input
						class="qtc-input"
						v-model="userEdit.address"
						placeholder="Dirección"
					></el-input>
				</el-form-item>
				<el-form-item prop="phone" class="mb-2 flex-40 mx-1">
					<el-input
						class="qtc-input"
						type="tel"
						v-model="userEdit.phone"
						placeholder="Teléfono"
					></el-input>
				</el-form-item>
				<el-form-item prop="phoneNumbers" class="mb-2 flex-40 mx-1">
					<el-input
						class="qtc-input"
						v-model="userEdit.phoneNumbers"
						placeholder="Celular"
					></el-input>
				</el-form-item>
				<br/>
				<div class="flex-95 d-flex align-center space-evenly mt-2">
					<button 
						type="button" 
						class="cancel-edit-btn"
						:style="`background-color:${globalColors.hover};border:0.1rem solid ${globalColors.hover}`"
						@click="goTo('account')"
					>Cancelar</button>
					<button 
						type="button" 
						class="account-summary-edit-btn"
						:style="`background-color:${globalColors.primary}`"
						@click="save"
					>Guardar</button>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import lib from '@/helpers/lib';
import selectComponent from '@/components/selectComponent';

const { merge, setNewProperty } = lib;

function created() {
	const user = { ...this.getUserInfo };
	user.phoneNumbers = user.phoneNumbers && user.phoneNumbers.length
		? user.phoneNumbers.join(', ')
		: null;
	this.userEdit = merge(
		user,
		this.userEdit,
	);
	this.loadData();
}

function documentLabel() {
	return this.isEcuador ? 'Cédula' : 'Dni';
}

function goTo(name) {
	this.$router.push({ name });
}

async function save() {
	const url = 'customers-public';
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const body = this.buildBody(this.userEdit);
	await this.$httpJapi.patch(url, body, { headers });
	this.getCustomerData();
}

async function getCustomerData() {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const { data: userInfo } = await this.$httpJapi.get('customers/current', { headers });
	userInfo.avatar = userInfo.urlImage || process.env.DEFAULT_AVATAR;
	userInfo.fullName = userInfo.typePerson.fullName;
	userInfo.dni = Number(userInfo.dni) ? userInfo.dni : null;
	this.$store.commit('SAVE_USER_INFO', userInfo);
	this.goTo('account');
}

function buildBody(user) {
	let body = {};
	this.fieldsToSave.forEach((f) => {
		body = setNewProperty(
			f,
			user[f],
		)(body);
	});
	if (!body.phoneNumbers) {
		body.phoneNumbers = [];
	} else {
		body.phoneNumbers = body.phoneNumbers.split(',');
	}
	return body;
}

async function loadData() {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	({ data: this.departments } = await this.$httpJapi.get('province', { headers }));
	if (this.userEdit.provinceId) {
		this.onDepartamenChange(this.userEdit.provinceId);
		if (this.userEdit.cityId) {
			this.onProvinceChange(this.userEdit.cityId);
		}
	}
}

async function onDepartamenChange(id, clean = false) {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	({ data: this.provinces } = await this.$httpJapi.get(`cities/${id}`, { headers }));
	if (clean) {
		this.userEdit.cityId = null;
		this.userEdit.parishId = null;
	}
}

async function onProvinceChange(id, clean = false) {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	({ data: this.districts } = await this.$httpJapi.get(`parish/${id}`, { headers }));
	if (clean) {
		this.userEdit.parishId = null;
	}
}

function data() {
	return {
		departments: [],
		districts: [],
		fieldsToSave: [
			'name',
			'lastname',
			'rzSocial',
			'address',
			'phone',
			'phoneNumbers',
			'ruc',
			'dni',
			'gender',
			'postalCode',
			'provinceId',
			'cityId',
			'countryId',
			'parishId',
		],
		provinces: [],
		userEdit: {
			name: null,
			lastname: null,
			gender: null,
			address: null,
			dni: null,
			ruc: null,
			postalCode: null,
			phoneNumbers: [],
			phone: null,
			provinceId: null,
			email: null,
			cityId: null,
			parishId: null,
		},
	};
}

export default {
	name: 'account-summary-edit',
	components: {
		selectComponent,
	},
	computed: {
		...mapGetters([
			'genders',
			'getUserInfo',
			'getUpdatedUserData',
			'token',
		]),
		documentLabel,
	},
	created,
	data,
	methods: {
		buildBody,
		getCustomerData,
		goTo,
		save,
		loadData,
		onDepartamenChange,
		onProvinceChange,
	},
};
</script>
<style lang="scss" scoped>
	.account-summary-edit {
		padding: 5rem;

		.wrapper-btn-back {
			background: color(defaultOrange);
			display: none;
			margin-bottom: 3.6rem;
			padding: 0.1rem 1rem;
			position: relative;
		}

		&-title {
			font-size: size(maxsmall);
		}

		.bold {
			font-weight: 800;
		}
		
		&-btn {
			border: none;
			color: color(white);
			cursor: pointer;
			display: block;
			font-size: size(large);
			height: 5rem;
			outline: none;
			width: 12.9rem;
		}

		.arrow-back {
			height: 1.5rem;
		}

		.title-btn {
			color: color(white);
			font-size: size(small);
		}

		&-back {
			background: none;
			border: none;
			outline: none;
			position: absolute;
			top: 33%;
		}
	}

	.cancel-edit-btn {
		color: white;
		cursor: pointer;
		font-size: size(large);
		height: 5rem;
		width: 12.9rem;
	}

	@media screen and (max-width: 768px) {
		.account-summary-edit {
			padding: 0;

			.wrapper-btn-back {
				display: block;
			}

			&-title {
				display: none;
			}
		}

		.account-summary-edit {
			.mr-2 {
				margin-right: 0;
			}
		}

		.wrapper-list-item {
			padding: 2rem 2.5rem;
		}
	}
</style>



// WEBPACK FOOTER //
// account-summary-edit.vue?30d1396b